import { useMemo } from "react";
import { Controller } from "react-hook-form";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { UnselectedFormOptionItem } from "@/components/ui/form/constants";
import { SelectField } from "@/components/ui/form/fields/select-field";

import { useGoogleFreeBookingLinksSettingsContext } from "../../../_context";

export const FormDefaultPlan = () => {
	const { form, connectablePlanList } = useGoogleFreeBookingLinksSettingsContext();
	const {
		control,
		formState: { errors },
	} = form;

	const options = useMemo(() => [UnselectedFormOptionItem, ...connectablePlanList], [connectablePlanList]);

	const connectablePlanExist = useMemo(() => {
		return connectablePlanList.length > 0;
	}, [connectablePlanList]);

	return (
		<QuestionForMain
			title={"連携するプラン"}
			required
			inputChildren={
				<div className="flex flex-col gap-y-4">
					<p>予約可能な部屋の中から、最も安い料金の部屋が連携されます。</p>

					<Controller
						name="defaultPlanID"
						control={control}
						render={({ field }) =>
							connectablePlanExist ? (
								<SelectField
									className="w-fit"
									value={field.value}
									options={options}
									errorMessage={errors?.defaultPlanID?.message}
									handleValueChange={(value) => {
										// 選択したプランがない場合は null を設定
										field.onChange(value === "null" ? null : value);
									}}
								/>
							) : (
								<p>選択できるプランがありません</p>
							)
						}
					/>
				</div>
			}
		/>
	);
};
